namespace OfficeGuy.Inputs {
    export class HTMLIFrame {
        static Init(Container?): void {
            $(".htmliframe[data-content]", Container).each(function () {
                var $Element = $(this);
                var ContentWindow = (<HTMLIFrameElement>this).contentWindow;
                ContentWindow.document.open();
                ContentWindow.document.write($Element.data("content"));
                ContentWindow.document.close();

                var $Head = $Element.contents().find("head");
                if ($Head.length == 0)
                    $Head = $Element.contents().find("html").prepend($(document.createElement('head')));
                $Head.append($('<style type="text/css">body { font-family: arial; line-height:1.5em; }</style>'));
                $Head.append($(document.createElement('base'))
                    .attr("target", "_blank"));

                $Element.on("load.htmliframe", function () {
                    HTMLIFrame.RefreshHeight($(this));
                });
                HTMLIFrame.RefreshHeight($Element);
            });
        }
        static RefreshHeight($IFrame) {
            if ($IFrame.is(":visible"))
                $IFrame.height($IFrame.contents().outerHeight());
        }
    }
}

$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.Inputs.HTMLIFrame.Init(Container);
});